import { action, observable, computed } from 'mobx';
import ChannelModel from './ChannelModel';
import TimelineModel from './TimelineModel';

import DefaultValues from '../../../AppDefaults';

export default class ChannelStore {
    @observable fetching = false;

    @observable fetchingTimeline = false;

    @observable fetchingTimelines = false;

    @observable fetched = false;

    @observable fetchedTimeline = false;

    @observable fetchedTimelines = false;

    @observable channel = {};

    @observable channels = [];

    @observable timeline = null;

    @observable timelines = [];

    @observable timelinesSchedule = [];

    @observable timelinesPlayout = [];

    @observable totalCount = 0;

    @observable limit = DefaultValues.limit;

    @observable page = 0;

    @observable date = null;

    @observable query = null;

    @observable type = null;

    auth = null;

    constructor(auth) {
        // Set auth
        this.auth = auth;
    }

    @computed
    get totalPageCount() {
        return Math.ceil(this.totalCount / this.limit);
    }

    @computed
    get filtered() {
        if (this.query) {
            const filteredList = this.channels.filter(
                (t) => t.name.toLowerCase().indexOf(this.query) > -1,
            );
            return filteredList;
        }
        // TODO mark query as wrong and show all anyways
        // if (filteredList.length) {
        //     return filteredList;
        // }
        return this.channels;
    }

    @action.bound
    fetch() {
        this.fetching = true;
        const params = {};
        if (this.type) {
            params.type = this.type;
        }
        if (this.query) {
            params.q = this.query;
        }
        if (this.limit) {
            params.limit = this.limit;
        }
        if (this.page) {
            params.offset = this.limit * this.page;
        }

        this.auth.apiGetWithTotalCount('/api/channels', params).then(
            action('update state after fetching data', ({ data, total }) => {
                const newList = data.map((item) => ChannelModel.fromJS(this.auth, item));
                this.channels.replace(newList);
                this.totalCount = total;
                this.fetched = true;
                this.fetching = false;
            }),
        );
    }

    @action.bound
    fetchChannel(id, start, end) {
        this.fetching = true;
        this.auth.apiGet(`/api/channels/${id}`).then(
            action('update state after fetching data', (data) => {
                const newOne = ChannelModel.fromJS(this.auth, data);
                this.channel = newOne;
                this.fetched = true;
                this.fetching = false;

                if (start && end && this.channel.settings && this.channel.settings.timelines) {
                    this.fetchTimelineSummaries(
                        this.channel.id,
                        start,
                        end,
                        this.channel.settings.timelines.playlist_layer_id,
                        this.channel.settings.timelines.schedule_layer_id,
                    );
                }
            }),
        );
    }

    @action.bound
    fetchTimelines(id) {
        this.fetchingTimelines = true;
        const params = {};
        if (this.type) {
            params.type = this.type;
        }
        if (this.query) {
            params.q = this.query;
        }
        if (this.limit) {
            params.limit = this.limit;
        }
        if (this.page) {
            params.offset = this.limit * this.page;
        }

        this.auth.apiGetWithTotalCount(`/api/channels/${id}/timelines`, params).then(
            action('update state after fetching data', ({ data, total }) => {
                const timelines = data.map((item) => TimelineModel.fromJS(this.auth, item));
                this.timelines.replace(timelines);
                this.totalCount = total;
                this.fetchedTimelines = true;
                this.fetchingTimelines = false;
            }),
        );
    }

    @action.bound
    fetchTimelineSummaries(id, start, end, playlistLayerId, scheduleLayerId) {
        this.fetchingTimelines = true;
        if (scheduleLayerId) {
            this.auth
                .apiGet(
                    `/api/channels/${id}/timelines/summary?layer_id=${scheduleLayerId}&start_date=${start}&end_date=${end}`,
                )
                .then(
                    action('update state after fetching data', (data) => {
                        const timelines = data.map((item) => TimelineModel.fromJS(this.auth, item));
                        this.timelinesSchedule.replace(timelines);
                        this.fetchedTimelines = true;
                        this.fetchingTimelines = false;
                    }),
                );
        } else {
            this.timelinesSchedule.replace([]);
        }
        if (playlistLayerId) {
            this.auth
                .apiGet(
                    `/api/channels/${id}/timelines/summary?layer_id=${playlistLayerId}&start_date=${start}&end_date=${end}`,
                )
                .then(
                    action('update state after fetching data', (data) => {
                        const timelines = data.map((item) => TimelineModel.fromJS(this.auth, item));
                        this.timelinesPlayout.replace(timelines);
                        this.fetchedTimelines = true;
                        this.fetchingTimelines = false;
                    }),
                );
        } else {
            this.timelinesPlayout.replace([]);
        }
    }

    @action.bound
    fetchTimeline(id, timelineId) {
        this.fetchingTimeline = true;
        this.auth.apiGet(`/api/channels/${id}/timelines/${timelineId}`).then(
            action('update state after fetching data', (data) => {
                const timeline = TimelineModel.fromJS(this.auth, data);
                this.timeline = timeline;
                this.fetchedTimeline = true;
                this.fetchingTimeline = false;
            }),
        );
    }

    // syncUpdate() {
    //     // this.auth.socket.syncUpdates('channels', this.assets);
    // }
    //
    // unsyncUpdates() {
    //     // this.auth.socket.unsyncUpdates('channels');
    // }

    toJS() {
        return this.assets.map((a) => a.toJS());
    }

    static fromJS(auth, array) {
        const store = new ChannelStore(auth);
        store.channels = array.map((item) => ChannelModel.fromJS(item));
        return store;
    }
}
